/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type { LibPRNG, LibPRNGInterface } from "../LibPRNG";

const _abi = [
  {
    inputs: [],
    name: "InvalidInitialLazyShufflerLength",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidNewLazyShufflerLength",
    type: "error",
  },
  {
    inputs: [],
    name: "LazyShuffleFinished",
    type: "error",
  },
  {
    inputs: [],
    name: "LazyShufflerAlreadyInitialized",
    type: "error",
  },
  {
    inputs: [],
    name: "LazyShufflerGetOutOfBounds",
    type: "error",
  },
  {
    inputs: [],
    name: "LazyShufflerNotInitialized",
    type: "error",
  },
] as const;

export class LibPRNG__factory {
  static readonly abi = _abi;
  static createInterface(): LibPRNGInterface {
    return new Interface(_abi) as LibPRNGInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): LibPRNG {
    return new Contract(address, _abi, runner) as unknown as LibPRNG;
  }
}
